<div class="modal-overlay" *ngIf="show" (click)="onClose()">
  <div class="modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>{{ 'satisfaction.replyModal.title' | translate }}</h3>
      <button class="btn-close" (click)="onClose()">×</button>
    </div>
    <div class="modal-body" *ngIf="feedback">
      <div class="feedback-info">
        <p><strong>{{ 'satisfaction.common.patientLabel' | translate }}</strong> {{ feedback.contact_email }}</p>
        <p><strong>{{ 'satisfaction.common.feedbackDateLabel' | translate }}</strong> {{ formatDate(feedback.created_at) }}</p>
        <p><strong>{{ 'satisfaction.common.ratingLabel' | translate }}</strong> {{ '⭐'.repeat(feedback.score || 0) }} ({{ feedback.score }}/5)</p>
        <p *ngIf="feedback.comment"><strong>{{ 'satisfaction.common.commentLabel' | translate }}</strong> {{ feedback.comment }}</p>
      </div>
      <div class="reply-form">
        <div class="template-select-wrapper">
          <label for="templateSelect" class="template-label">
            <svg class="template-icon" viewBox="0 0 24 24" fill="currentColor">
              <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
            </svg>
            {{ 'satisfaction.common.templateLabel' | translate }}
          </label>
          <select
            id="templateSelect"
            class="template-select"
            [(ngModel)]="selectedTemplate"
            (change)="onTemplateSelect()">
            <option value="">{{ 'satisfaction.common.chooseTemplateOption' | translate }}</option>
            <option *ngFor="let template of emailTemplates()" [value]="template.name">{{ template.name }}</option>
          </select>
        </div>

        <label for="replySubject">{{ 'satisfaction.common.subjectLabel' | translate }}</label>
        <input
          id="replySubject"
          type="text"
          class="subject-input"
          [(ngModel)]="replySubject"
          [placeholder]="'satisfaction.common.subjectPlaceholder' | translate">

        <label for="replyMessage">{{ 'satisfaction.common.messageLabel' | translate }}</label>
        <textarea
          id="replyMessage"
          class="message-textarea"
          [(ngModel)]="replyMessage"
          rows="5"
          [placeholder]="'satisfaction.replyModal.messagePlaceholder' | translate"></textarea>

        <div class="reply-success" *ngIf="replySuccess">{{ replySuccess }}</div>
        <div class="reply-error" *ngIf="replyError">{{ replyError }}</div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn-no-reply" (click)="onNoReply()">{{ 'satisfaction.common.closedWithoutContact' | translate }}</button>
      <div class="footer-right">
        <button class="btn-cancel" (click)="onClose()">{{ 'common.actions.cancel' | translate }}</button>
        <button class="btn-send" (click)="onSendReply()" [disabled]="!replyMessage.trim() || replyLoading">
          {{ (replyLoading ? 'satisfaction.common.sending' : 'common.actions.send') | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<app-confirm-modal
  *ngIf="showConfirmNoReply"
  [title]="'satisfaction.common.confirmationTitle' | translate"
  [message]="'satisfaction.common.closeWithoutReplyConfirmMessage' | translate"
  [confirmText]="'common.actions.confirm' | translate"
  [cancelText]="'common.actions.cancel' | translate"
  (confirm)="onConfirmNoReply()"
  (cancel)="onCancelNoReply()">
</app-confirm-modal>

<app-confirm-modal
  *ngIf="showConfirmSend"
  [title]="'satisfaction.replyModal.confirmSendTitle' | translate"
  [message]="'satisfaction.replyModal.confirmSendMessage' | translate"
  [confirmText]="'common.actions.send' | translate"
  [cancelText]="'common.actions.cancel' | translate"
  (confirm)="onConfirmSend()"
  (cancel)="onCancelSend()">
</app-confirm-modal>